/**************************************************
 * Nombre:       Formulario_Banner
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, PhoneAndroidOutlined, ShortTextOutlined, TextFormatOutlined, TitleOutlined,AccountCircleOutlined,EditAttributesOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {useState} from "react";

const Formulario_Banner = ({...props}) => {
    const [tipo, setTipo] = useState('Azul');


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectFuncion Icono={Flag} nombre={'Tipo'} dato={'tipo'} {...props}
                                          requerido={'Campo requerido'}
                                          opciones={['Azul', 'Naranja']} setDato={setTipo}
                    />
                </Grid>


                {tipo === 'Azul' ?

                    <>
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <IngresoImagenCrop dato={'img'} alto={30} ancho={42} {...props}  />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 14}}>**Imagen de 840px por 600px de menos de 300K de peso</Typography>
                        </Grid>

                        <Grid container size={12}>
                            <IngresoTexto Icono={ShortTextOutlined} nombre={'Texto Pequeño'}
                                          dato={'subTituloUno'} {...props}

                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <IngresoTexto Icono={TitleOutlined} nombre={'Texto muy corto'}
                                          dato={'nombre'} {...props}
                            />
                        </Grid>

                        <Grid container size={12}>
                            <IngresoTexto Icono={TextFormatOutlined} nombre={'Texto pequeño dos'}
                                          dato={'subTituloDos'} {...props}

                            />

                        </Grid>

                    </>

                    :

                    <>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <IngresoImagenCrop dato={'img'} alto={50} ancho={75} {...props}  />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 14}}>**Imagen de 750px por 500px de menos de 300K de peso</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <IngresoTexto Icono={TitleOutlined} nombre={'Titulo de Banner'}
                                          dato={'nombre'} {...props}
                            />
                        </Grid>

                        <Grid container size={12}>
                            <IngresoTexto Icono={TextFormatOutlined} nombre={'Titulo del autor'}
                                          dato={'titulo'} {...props}

                            />

                        </Grid>

                        <Grid container size={12}>
                            <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre Autor (Autor del Blog)'}
                                          dato={'autor'} {...props}
                            />
                        </Grid>


                    </>
                }









                <Grid container size={12}>
                    <IngresoTexto Icono={EditAttributesOutlined} nombre={'Link Bonton'} dato={'link'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Banner